import { render, staticRenderFns } from "./UserActionsModal.vue?vue&type=template&id=136f3b13&scoped=true&"
import script from "./UserActionsModal.vue?vue&type=script&lang=js&"
export * from "./UserActionsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserActionsModal.vue?vue&type=style&index=0&id=136f3b13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136f3b13",
  null
  
)

export default component.exports